export default __webpack_public_path__ + "static/media/Group 8578.647acf74.svg";